module.exports = __webpack_public_path__ + "img/basis.bc6a2c62.png";